<script setup lang="ts">
import Footer from './components/Footer.vue';
import Header from './components/Header.vue';

useHead({
  htmlAttrs: {
    lang: 'en',
  },
  link: [
    {
      rel: 'icon',
      type: 'image/svg+xml',
      href: '/favicon.svg',
    },
  ],
});
</script>

<template>
  <div class="error">
    <Header />
    <main class="error__main">
      <h1 class="error__title">Oops something went wrong</h1>
      <p>
        Sorry, we couldn't find the page you were looking for, you can
        <NuxtLink to="/">return to the home page here</NuxtLink>.
      </p>
    </main>
    <Footer />
  </div>
</template>

<style scoped lang="scss">
.error {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  &__main {
    margin: 0 11rem;
  }

  &__title {
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 2rem;
  }
}
</style>
